module.exports = __webpack_public_path__ + "static/media/img2.2b27ebd5.webp";